import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBadgeResource } from "../types";

export type IBadgePatchMutationParameters = {
    badge: RelationalValue<IBadgeResource>;
    data: {
        name?: string;
        template?: string;
    };
};

export type IBadgePatchMutationResult = IBadgeResource;

export const badgePatchMutation: IApiMutationFunction<IBadgePatchMutationParameters> = ({ badge, data }) => {
    return {
        method: "PATCH",
        url: `/badges/${mapRelationalValue(badge)}`,
        data,
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
    };
};

export const useBadgePatchMutation = createApiMutationHook<IBadgePatchMutationParameters, IBadgePatchMutationResult>(
    badgePatchMutation,
);
